import { useEffect } from 'react'

const styles = `
    .widget-container.full-widget {
        border: 1px solid #dedede;
    }

    .widget-content-container.full-widget {
        padding: 0 !important;
    }

    .widget-content.full-widget {
        padding: 0 !important;
        width: 100% !important;
        height: 100% !important;
    }

    .widget-footer.full-widget {
        display: none;
    }

    .widget-header.full-widget {
        min-height: 32px;
        padding: 0 12px !important;
        z-index: 2;
    }

    .widget-description.full-widget {
        height: 20px;
        margin: 6px 0px -26px !important;
    }

    .widget-title.full-widget {
        height: 32px !important;
        line-height: 32px !important;
        margin-bottom: 0;
    }

    .widget-title.full-widget::after {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 32px;
        content: " ";
        background: #f1f1f1;
        z-index: -1;
    }

    .widget-filters.full-widget {
        display: none;
    }
`

/**
 * Remove padding from Live Widget.
 * @param ref
 */
export function useFullWidget(ref) {
    useEffect(function () {
        const style = document.createElement('style')
        style.type = 'text/css'
        style.id = 'full-widget-style'
        style.innerHTML = styles
        if (!document.getElementById('full-widget-style')) {
            document.head.appendChild(style)
        }

        if (ref.current) {
            const widgetContent = ref.current.parentNode
            if (widgetContent) {
                widgetContent.classList.add('full-widget')

                const widgetContainer = widgetContent.parentNode
                if (widgetContainer) {
                    widgetContainer.classList.add('full-widget')

                    const parentNode = widgetContainer.parentNode
                    if (parentNode) {
                        parentNode.classList.add('full-widget')

                        const footer = parentNode.querySelector('.widget-footer')
                        if (footer) {
                            footer.classList.add('full-widget')
                        }

                        const header = parentNode.querySelector('.widget-header')
                        if (header) {
                            header.classList.add('full-widget')

                            const timespan = header.querySelector('.widget-description')
                            if (timespan) {
                                timespan.classList.add('full-widget')
                            }

                            const title = header.querySelector('.widget-title')
                            if (title) {
                                title.classList.add('full-widget')
                            }
                        }
                    }
                }
            }
        }
    })
}
